import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8 3.5h7-7zm3.5.5v3-3zM3 12.5H0h3zM.5 9v7-7zm18 6.5v1.6c0 1.4-1.2 1.4-1.2 1.4H10l-2.6-3H3.5V9.1L7 6.5h7.8l3.7 4h2v-2h1c1.1 0 2 .9 2 2v5c0 1.1-.9 2-2 2h-1v-2h-2z" stroke="currentColor" fill="none" /></svg>;